


























































































































































































































































































































































































import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import Customer, { customerInitValue } from '@/types/customer/Customer';
import UserInterface from '@/types/app/IUser';
import CustomerService from '@/services/customerService';
import { getFileNameFromLink } from '@/utils/fileName';
import formatDate, { formatDateWithTime } from '@/utils/formatDate';
import Endpoint from '@/utils/endpoint';
import ModalSuccess from '@/components/common/ModalSuccess.vue';
import VuetifySelectItems from '@/types/app/vuetifySelectItems';
import BaseComponent from '@/utils/baseComponent';
import CompanyService from '@/services/companyService';

const namespace = 'customer';

@Component({
  components: { ModalSuccess },
  data: () => ({
    isLCM: false,
    endpoint: new Endpoint(),
    required: (v: any) => !!v || 'This field is required',
  }),
  watch: {   
    customer: async function (val: Customer) {
      this.$data.isLCM = await new CustomerService(this.$http).hasLCMRole(
        val.email
      ); //roles.includes('lcm');
    },
  },
})

export default class CustomerForm extends BaseComponent {

  @Getter('getModalCustomerState', { namespace: 'customer' })
  modalCustomerState!: boolean;
 @Action('setModalCustomerState', { namespace: 'customer' })
  setModalCustomerState!: any;

  companyService = new CompanyService(this.$http);
  customerService = new CustomerService(this.$http);

  @Getter('getUser', { namespace: 'auth' }) user!: UserInterface;
  companies: VuetifySelectItems[] = [];
  openSuccessModal = false;
  openSuccessModalMessage = 'Deleted customer with success!';
  getFileNameFromLink = getFileNameFromLink;
  formatDate = formatDate;
  formatDateWithTime = formatDateWithTime;
  customer:Customer = customerInitValue;
  isLCM = false;
  isEdit = false;
  private endpoint = new Endpoint();
  classification = [
    { text: 'Us Person', value: 0 },
    { text: 'Non Us Person', value: 1 },
    { text: 'All', value: 2 },
  ];
  investorTypes = [
    { value: 0, text: 'As a Natural Person' },
    { value: 1, text: 'As a Corporate, Foundation, Endowment, Company or LLC' },
    {
      value: 2,
      text: 'As a Trust, Bank, Savings and Loan (or similar Institution) or Insurance Company',
    },
    {
      value: 3,
      text: 'Via an Employee Benefit Plan, Individual Retirement Account, or Keogh Plan',
    },
  ];
  loading = false;
  loadingEdit = false;
  customerSentLoading = false;
  errorCreate = false;
  errorMessage = '';

  async mounted() {
    this.companies = await this.companyService.getCompanyItems();
    this.customer = await this.customerService.getCustomerById(this.customerId);
  }

  goTo(page:string){
    this.$router.push({
      name: "UserForm",
      params: {
        customerId: this.customer.id,
        formType: page,
      }
    });
  }

  get customerId(): string {
        return this.$route.params.customerId
  }

  get formType(): string {
        return this.$route.params.formType
    }

  get relationShip(): string {
    if (this.customer && this.customer.relationships) {
      for (let i = 0; i < this.customer.relationships.length; i++) {
        if (this.customer.relationships[i].typeRelationship === 1) {
          return this.customer.relationships[i].name;
        }
      }
    }

    return '';
  }

  get scheduleDone(): boolean {
    return this.customer?.scheduleIndexResponse?.status != 'done';
  }

  get veriffApproved(): boolean {
    return this.customer?.veriffResponse?.verification?.status != 'approved'
  }

  get evaluator(): string {
    if (this.customer && this.customer.relationships) {
      for (let i = 0; i < this.customer.relationships.length; i++) {
        if (this.customer.relationships[i].typeRelationship === 0) {
          return this.customer.relationships[i].name;
        }
      }
    }

    return '';
  }

  async selfScheduling() {
    try {
      const res = await this.$http.post(this.endpoint.scheduling, {
        id: 'LESTE-FAKE-SCHEDULE',
        data: {
          subject: '30-minute meeting',
          status: 'done',
          creation_time: new Date(),
          starting_time: new Date(),
          owner: 'Ben Jackson',
          duration_minutes: 30,
          virtual_or_physical_location:
            'https://teams.microsoft.com/l/meetup-join/',
          cancel_reschedule_link: 'https://go.oncehub.com/signup',
          form_submission: {
            email: this.customer.email,
          },
          booking_page: {
            publicName: 'Signup',
            internalLabel: 'Signup',
            link: 'https://go.oncehub.com/signup',
          },
        },
      });

      if (res) {
        this.customer.scheduleIndexResponse = {
          subject: '30-minute meeting',
          cancelRescheduleLink: '',
          creationTime: new Date().toDateString(),
          status: 'done',
          owner: 'Ben Jackson',
          durationMinutes: 30,
          entryDate: new Date().toDateString(),
          scheduleStatus: 0,
          startingTime: new Date().toDateString(),
          bookingPage: {
            publicName: 'Signup',
            internalLabel: 'Signup',
            link: 'https://go.oncehub.com/signup',
          },
        };

        this.showSuccess('Scheduling process skipped!');
      }
    } catch (error) {
      console.error(error);
    }
  }

  async selfKyc() {
    try {
      this.loadingEdit = true;
      const res = await this.$http.post(
        `${this.endpoint.skipKyc}/${this.customer.id}`
      );

      if (res) {
        this.showSuccess('KYC process skipped!');
        this.customer.veriffResponse = {
          status: 'success',
          verification: { status: 'approved' },
        };
      }
      this.loadingEdit = false;
    } catch (error) {
      this.loadingEdit = false;
      console.error(error);
    }
  }

  async forgetPassword() {
    try {
      this.loadingEdit = true;
      const res = await this.$http.put(
        `${this.endpoint.forgetPassword}`, { userId: this.customer.id, email: this.customer.email }
      );
      this.errorCreate = false;
      this.errorMessage = '';
      if (!res.data?.hasError) {
        this.showSuccess('Send password to email with success!');
        this.customer.veriffResponse = {
          status: 'success',
          verification: { status: 'approved' },
        };
      }
      else {
        this.errorMessage = res.data?.messageError.join('<br />');
        this.errorCreate = true;
        this.loadingEdit = false;
      }
    } catch (error) {
      this.loadingEdit = false;
      console.error(error);
    }
  }

  async setRole() {
    const roles = ['customer'];
    this.loadingEdit = true;
    if (this.isLCM) roles.push('lcm');
    const res = await this.$http.put(this.endpoint.setRole, {
      email: this.customer.email,
      roles,
    });
    this.loadingEdit = false;
    this.showSuccess('Modified client user with successfully!!')
  }

  async setLesteManager(){
    this.loadingEdit = true;
    const res = await this.$http.put(`${this.endpoint.lesteUserSetIsManager}/${this.customer.id}/${this.customer.hasLesteManagerRole}`);
    this.loadingEdit = false;
    this.showSuccess('Modified client user with successfully!!')
  }

  get wasApproved(): boolean {
    return (
      this.customer.scheduleIndexResponse != null &&
      this.customer.scheduleIndexResponse.status === 'Done'
    );
  }

  
  backToHome(): void {
    this.openSuccessModal = false;
    this.$router.push({ path: '/customers' });
  }
  saveCustomer(): void {

    if (this.form().validate()) {
      this.loadingEdit = true;

      try {
        const url = this.endpoint.customers + '/backoffice';

        this.$http
          .put(`${url}`, {
            customer: {
              firstName: this.customer.firstName,
              lastName: this.customer.lastName,
              country: this.customer.country,
              phone: this.customer.phone,
              email: this.customer.email,
              userId: this.customer.id,
              typePerson: this.customer.investorType,
              classification: this.customer.classification,
              companyId: this.customer.companyId
            },
          })
          .then((res: any) => {
            this.customer.fullName =
              this.customer.firstName + ' ' + this.customer.lastName;
            this.customer.howDoYouRank =
              this.classification[this.customer.classification].text;
            this.customer.investorTypeDesc =
              this.investorTypes[this.customer.investorType].text;


            this.$http
              .put(this.endpoint.createUser, {
                name: this.customer.fullName,
                email: this.customer.email,
                phoneNumber: this.customer.phone,
                classification: this.customer.classification,
                id: this.customer.id,
              })
              .then((res: any) => {
                this.showSuccess('Saved customer with success!!');
                this.loadingEdit = false;
                this.goTo('view');
              })
              .catch((err) => {
                this.loadingEdit = false;
                console.error(err);
              });

          })
          .catch((err) => {
            this.loadingEdit = false;
            console.error(err);
          });
      } catch (error) {
        this.loadingEdit = false;
        console.error(error);
      }
    }
  }

  closeModal(): void {
    this.setModalCustomerState(false);
  }
}
